import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
// @material-ui/core components
import { useMediaQuery } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { makeStyles, useTheme } from "@material-ui/core/styles";
// @material-ui/icons components
import HelpIcon from "@material-ui/icons/Help";
//import custom components

import componentStyles from "assets/theme/views/admin/static-page.js";
import LocationHeader from "components/Headers/LocationHeader";
import { labels } from "resources/resources";

const useStyles = makeStyles(componentStyles);

function FAQs() {
  const classes = useStyles();
  const intl = useIntl();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  const quickGuides = [
    {
      title: intl.formatMessage(labels.Label_Menu_Help_FAQs_HowToRegisterInInefop),
      path: "Register_FO_user.pdf",
    },
    {
      title: intl.formatMessage(labels.Label_Menu_Help_FAQs_HowToRecoverPassword),
      path: "Password_Recovery.pdf",
    },
    {
      title: intl.formatMessage(labels.Label_Menu_Help_FAQs_HowToUpdatePersonalData),
      path: "Update_Personal_Information.pdf",
    },
    {
      title: intl.formatMessage(labels.Label_Menu_Help_FAQs_HowToApplyToAJob),
      path: "Employment_And_Internship_Application.pdf",
    },
    {
      title: intl.formatMessage(labels.Label_Menu_Help_FAQs_HowToApplyToGovernmentSupports),
      path: "Government_Supports_Application.pdf",
    },
    {
      title: intl.formatMessage(labels.Label_Menu_Help_FAQs_UpdateMyProfile),
      path: "Update_My_Profile.pdf",
    },
    {
      title: intl.formatMessage(labels.Label_Menu_Help_FAQs_SubmitRENT),
      path: "Submit_RENT.pdf",
    },
    {
      title: intl.formatMessage(labels.Label_Menu_Help_FAQs_SubmitContractApproval),
      path: "Submit_Contract_Approval.pdf",
    },
    {
      title: intl.formatMessage(labels.Label_Menu_Help_FAQs_SubmitRENTMapAPI),
      path: "Submit_Map_Rent_API.pdf",
    },
  ];

  return (
    <Container maxWidth={false} classes={{ root: classes.containerRoot }}>
      <Box marginLeft={isSmDown ? 0 : "-30px"}>
        <LocationHeader section={intl.formatMessage(labels.Label_Menu_Help_FAQs)} />
      </Box>
      <Grid container>
        <Grid item xs={12}>
          <Card className={classes.cardRoot}>
            <CardContent>
              <Grid item xs={12} md={12}>
                <Box classes={{ root: classes.pageTitle }}>{intl.formatMessage(labels.Label_Menu_Help_FAQs)}</Box>
              </Grid>

              <Grid item xs={12} md={12}>
                <List dense={true}>
                  {quickGuides.map((item, key) => (
                    <ListItem key={key}>
                      <Box display="flex" alignItems="center" gridGap={12} width="100%">
                        <HelpIcon className={classes.helpIcon} />
                        <Box flex={1} minWidth={0}>
                          <Link to={"/quick-guides/" + item.path} target="_blank" className={classes.linkStandard}>
                            {item.title}
                          </Link>
                        </Box>
                      </Box>
                    </ListItem>
                  ))}
                </List>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

const mapStateToProps = (state) => ({ ...state });

export default connect(mapStateToProps)(FAQs);
